import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const ViolationDetailsContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  alignItems: 'start',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
}));

export const ViolationsInfoContainer = styled(Box)(() => ({
  display: 'flex',
  height: '100%',
  minHeight: '200px',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
}));
